export const ROUTES = {
  AUTH: {
    SIGN_IN: '/auth/sign-in',
    SIGN_UP: '/auth/sign-up',
  },
  HOME: '/',
  RECRUITER: {
    JOB_LIST: '/jobs-list',
    MY_CANDIDATE: '/my-candidates',
    EDIT_PROFILE: '/edit-profile',
    MY_PAYMENT: '/my-payment',
  },
  ADMIN: {
    DASHBOARD: '/dashboard',
    CLIENT: '/client',
    JOB: '/job',
    APPLICATION: '/application',
    RECRUITER: '/recruiter',
    RECRUITER_DETAIL: '/recruiter/:id',
    CANDIDATE: '/candidate',
    CANDIDATE_DETAIL: '/candidate/:id',
    USER_SETTING: '/user-setting',
    AUTH: '/auth/sign-in',
    AI_ASSISTANT: '/ai-assistant',
    PAYMENT: '/payment',
  },
};

export const DOMAIN_RECRUITER = 'kiteshr.com';
export const DOMAIN_ADMIN = 'admin.kiteshr.com';
export const AWS_S3_RESUME_URL = 'https://eduto-bucket.s3.ap-southeast-1.amazonaws.com/pdfs/';

// export const DOMAIN_RECRUITER = 'kiteshr.com';
// export const DOMAIN_ADMIN = 'admin.kiteshr.com';
